import { i18n } from '@/i18n';
import onboardingOccupationRegExp from '@/rules/regexp/Occupation';
import { FormKitRule } from '@/types/interfaces/ValidationRule.interface';

/** @deprecated Should export just FormKitPattern. Rule part should be removed, use 'matches' with imported regex instead. */
export const OccupationFormKitRule: FormKitRule = {
  name: 'occupation',
  rule: (node) => typeof node.value === 'string' && !onboardingOccupationRegExp.expression.test(node.value),
  message: ({ name }) => i18n.global.t('validation.invalid_field', [name]),
  validation: 'required|length:0,200',
  pattern: {
    expression: onboardingOccupationRegExp.expression,
    maxlength: 200,
  },
};
